import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const getAllSubscriptionByRole = (role) => {
  return Api(
    `${endPoints.getAllSubscriptionByRole}?role=${role}&isActive=true`,
    null,
    requestType.GET,
  );
};

const getAdminSetting = () => {
  return Api(endPoints.getSetting, null, requestType.GET);
};

export { getAllSubscriptionByRole, getAdminSetting };
